"use client"

const faqs = [
  {
    id: "which-pve",
    question: "Which Proxmox versions are supported?",
    answer:
      "PVE 7.4 and newer. Each release tested against the two latest minor versions of 8.x and 9.x.",
  },
  {
    id: "licences",
    question: "Do I need licences for Windows / macOS?",
    answer:
      "Yes. We provide the template / script infrastructure. You provide a legal Windows key or Apple hardware ownership & compatible hardware for macOS.",
  },
  {
    id: "updates",
    question: "How do updates work?",
    answer:
      "Most OSs can be updated from within, ensure you take a backup before updating however, just in case things don't go to plan!",
  },
  {
    id: "custom",
    question: "Can I get custom templates?",
    answer:
      "Yes — that lives under consulting. our standard package includes one custom template; bigger libraries are scoped per project.",
  },
  {
    id: "offline",
    question: "Does it work offline",
    answer:
      "Partially. The script downloads templates to your server through our CDN, once you have templates downloaded you can restore these offline.",
  },
]

export function FaqSection() {
  return (
    <section style={{ padding: "64px 48px 80px" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto" }}>
        {/* Section header */}
        <div style={{ marginBottom: 32 }}>
          <div
            className="font-mono"
            style={{
              fontSize: 12,
              color: "var(--accent)",
              letterSpacing: "0.04em",
              marginBottom: 12,
            }}
          >
            # faq
          </div>
          <h2
            style={{
              fontSize: 36,
              fontWeight: 600,
              letterSpacing: "-0.03em",
              color: "var(--text)",
            }}
          >
            Questions we hear a lot.
          </h2>
        </div>

        {/* FAQ accordion */}
        <div
          style={{
            border: "1px solid var(--border)",
            borderRadius: 6,
            overflow: "hidden",
          }}
        >
          {faqs.map((faq, i) => (
            <details
              key={faq.id}
              open={i === 0}
              style={{
                borderTop: i === 0 ? "none" : "1px solid var(--border)",
              }}
            >
              <summary
                className="font-mono"
                style={{
                  padding: "18px 20px",
                  cursor: "pointer",
                  listStyle: "none",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: 13,
                  color: "var(--text)",
                  background: "var(--bg)",
                }}
              >
                <span>
                  <span style={{ color: "var(--muted)" }}>?</span> {faq.question}
                </span>
                <span style={{ color: "var(--accent)" }}>↗</span>
              </summary>
              <p
                style={{
                  padding: "0 20px 18px",
                  marginTop: -4,
                  color: "var(--text-2)",
                  fontSize: 14,
                  lineHeight: 1.65,
                  maxWidth: 760,
                  background: "var(--bg)",
                }}
              >
                {faq.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  )
}
